import { Box, Stack } from "@mui/material";
import Head from "next/head";

import Logo from "../../../assets/images/omi_logo.svg";
import { EnvironmentBar } from "../../../components/layout/EnvironmentBar";

const CONTAINER_ID = "content-container";

interface IProps {
    title?: string;
    actions?: React.ReactNode;
    showHeaderLogo?: boolean;
}

export const OmiMinimalLayout: React.FC<React.PropsWithChildren<IProps>> = ({
    title,
    children,
    actions,
    showHeaderLogo,
}) => {
    return (
        <>
            <Head>
                <title>{title ? `Omi | ${title}` : "Omi"}</title>
            </Head>
            <EnvironmentBar />
            <Stack alignItems="center" spacing={3} width="100%" py={3}>
                <Stack
                    flex={1}
                    width="100%"
                    maxWidth={(theme) => theme.formMaxWidths.page}
                    px={{ xs: 0.5, sm: 3, lg: 5 }}
                    spacing={2}
                    alignItems="flex-start"
                >
                    <Stack alignItems="center" direction="row" justifyContent="space-between" width="100%">
                        <Stack>{showHeaderLogo && <Logo />}</Stack>
                        <Stack direction="row" spacing={1}>
                            {actions}
                        </Stack>
                    </Stack>

                    <Box id={CONTAINER_ID} display="flex" justifyContent="center" alignSelf="center" width="100%">
                        {children}
                    </Box>
                </Stack>
            </Stack>
        </>
    );
};
